import React, { useState } from "react";
import LogInPopups from "./LogInPopups";
import SignUpPopup from "../SignUp/SignUpPopup";
import LogInButton from "./LogInButton";

const AuthPopupManager = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  // 🔹 After successful login → close popup and notify NavBar
  const handleLoginSuccess = () => {
    setShowLogin(false);
    // notify NavBar immediately
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <>
      {/* ✅ Only Log In button shows on the first page */}
      <LogInButton onOpenLogin={() => setShowLogin(true)} />

      {/* Login Popup */}
      <LogInPopups
        show={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToSignUp={() => {
          setShowLogin(false);
          setShowSignup(true); // open signup
        }}
        onLoginSuccess={handleLoginSuccess} // 🔹 pass success handler
      />

      {/* Signup Popup (opened only from inside Login popup) */}
      <SignUpPopup
        show={showSignup}
        onClose={() => setShowSignup(false)}
        onSwitchToLogin={() => {
          setShowSignup(false);
          setShowLogin(true); // go back to login
        }}
      />
    </>
  );
};

export default AuthPopupManager;
